export const group_data = {
    groups: ["1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "2A", "2B", "2C", "2D", "2E", "2F", "2G", "2H", "16限目の碧", /*"つるばみ同好会",*/ "化学部", "工作サークル", "SDGsの会", "『あの頃は、純粋だった。』制作委員会", "古文の会", "地球温暖化に対抗する会", "練馬区民の会", "パスタが少し余っていたので・・・", "町田市民の会", "75期HR委員会", "CR東日本", "NERV西高支部", "NISHI FLYER", "origamiサークル", "宇宙研究部", "架空同好会", "華道部", "かるた部", "数学研究同好会", "西論会", "文芸部", "歴史研究部", "74期サークル志記", "ダンス部75×76", "剣道部", "浪漫倶楽部", "ヲタ芸サークル", "図書委員会", "執行委員会", "生物部", "管弦楽部", "第2音楽部", "吹奏楽部", "秘密結社ベトリナ", "ワンダーフォーゲル部", "Lily", "シュベルト", "新体操有志", "NBA", /*"スタジオふれ",*/ "放送部", "74th食販有志", "園芸部", "NIN", "Pas de Huit (パドユイット)", "写真部", "新聞部", "卵かけご飯同好会", "都立西高等学校駄洒落倶楽部", "ポケモン研究サークル", "イラスト研究部", "美術部", "物理部", "NWO74th", "aile", /*"Brass Band Basics",*/ "BTMⅡ", "FM75×76", /*"Western Spring",*/ "軽音楽同好会", "ケルト音楽研究サークル", "ゴスペルフリークス部", "鼓絆", "シブ楽隊", /*"男子バスケットボール部", "ふえ部", "管打の集い"*/],
    group_info: {
        "1A": {
            location: "1年A組教室",
            show_name: "神隠し",
            img: "/img/num1-min.jpeg",
            number: "No.001",
            category: ["アトラクション"],
            type: "class",
            msg: "あなたはとある神社の夏祭りに来ている。この神社にはとある噂があるらしい。あなたにはこの噂の真実を解明できるか？",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "1B": {
            location: "1年B組教室",
            show_name: "羅生門\n〜老婆の逆襲〜",
            img: "/img/num2-min.JPG",
            number: "No.002",
            category: ["映像"],
            type: "class",
            msg: "ある日の西高のことである。一人の老婆が羅生門の下で復讐の念に燃えていた･･･\n1ｰBの羅笑門ご覧あれ！",
            time_info_1day: [
                {schedule: "9:00~9:25", time: "25min", category: "映像"},
                {schedule: "9:55~10:20", time: "25min", category: "映像"},
                {schedule: "10:50~11:15", time: "25min", category: "映像"},
                {schedule: "11:45~12:10", time: "25min", category: "映像"},
                {schedule: "13:10~13:35", time: "25min", category: "映像"},
                {schedule: "14:05~14:30", time: "25min", category: "映像"},
                {schedule: "15:00~15:25", time: "25min", category: "映像"},
                {schedule: "15:55~16:20", time: "25min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:25", time: "25min", category: "映像"},
                {schedule: "9:55~10:20", time: "25min", category: "映像"},
                {schedule: "10:50~11:15", time: "25min", category: "映像"},
                {schedule: "11:45~12:10", time: "25min", category: "映像"},
                {schedule: "13:10~13:35", time: "25min", category: "映像"},
                {schedule: "14:05~14:30", time: "25min", category: "映像"},
                {schedule: "15:00~15:25", time: "25min", category: "映像"},
                {schedule: "15:55~16:20", time: "25min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/1b",
            point :"auto",
            underLine: "underlines"
        },
        "1C": {
            location: "1年C組教室",
            show_name: "Cテレビジョン\nネットワーク",
            img: "/img/num3-min.jpeg",
            number: "No.003",
            category: ["映像"],
            type: "class",
            msg: "弊社は皆様に楽Cを提供します。",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:30~11:20", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "15:00~15:50", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:30~11:20", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "15:00~15:50", time: "50min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/1c",
            point :"auto",
            underLine: "underlines"
        },
        "1D":{
            location: "1年D組教室",
            show_name: "Derivation",
            img: "/img/num4-min.jpeg",
            number: "No.004",
            category: ["映像"],
            type: "class",
            msg: "Dから始まる単語をテーマにクラスを４グループに分けて作った奇跡の4部作！瞬き厳禁の4D映像を刮目せよ！\n ※4DとはDream Destiny Dungeon Densetsu(伝説)の頭文字のことです。",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "14:50~15:40", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "14:50~15:40", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "1E": {
            location: "1年E組教室",
            show_name: "姫と豚とジュリエット",
            img: "/img/num5-min.jpeg",
            number: "No.005",
            category: ["映像"],
            type: "class",
            msg: "白雪姫、シンデレラ、三匹の子豚、ロミオとジュリエットを私たちなりにアレンジして上映します！夜露死苦☆☆☆",
            time_info_1day: [
                {schedule: "9:00~9:40", time: "40min", category: "映像"},
                {schedule: "10:20~11:00", time: "40min", category: "映像"},
                {schedule: "11:40~12:20", time: "40min", category: "映像"},
                {schedule: "13:20~14:00", time: "40min", category: "映像"},
                {schedule: "14:40~15:20", time: "40min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:40", time: "40min", category: "映像"},
                {schedule: "10:10~10:50", time: "40min", category: "映像"},
                {schedule: "11:20~12:00", time: "40min", category: "映像"},
                {schedule: "13:00~13:40", time: "40min", category: "映像"},
                {schedule: "14:10~14:50", time: "40min", category: "映像"},
                {schedule: "15:20~16:00", time: "40min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/1e",
            point :"auto",
            underLine: "underlines"
        },
        "1F": {
            location: "1年F組教室",
            show_name: "The Gambler",
            img: "/img/num6-min.jpeg",
            number: "No.006",
            category: ["アトラクション"],
            type: "class",
            msg: "Gamblerの皆様ようこそ。今宵のゲームで皆様の運を試してみませんか？？1Fの紳士と淑女に勝てばこの先幸運が訪れるでしょう。それでは夜のギャンブルへいってらっしゃい",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "1G": {
            location: "1年G組教室",
            show_name: "君ノ名ハ。",
            img: "/img/num7-min.jpg",
            number: "No.007",
            category: ["映像"],
            type: "class",
            msg: "爆発的大ヒットから5年。あの名作が帰ってきた！西高を舞台に繰り広げられる感動の西春をあなたへ。",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "14:50~15:40", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "14:50~15:40", time: "50min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/1g",
            point :"auto",
            underLine: "underlines"
        },
        "1H":{
            location: "1年H組教室",
            show_name: "Grand Escape",
            img: "/img/num8-min.jpg",
            number: "No.008",
            category: ["アトラクション"],
            type: "class",
            msg: "1Hに来たあなたは、とある事件の犯人と間違えられて、地下深くの牢獄に閉じ込められてしまった！こうなったら、どうにか脱獄するしかない。チャンスは、見張りが目を離す数分間のみ。その短時間で所々にある扉のロックを解除し、地上へ出ることはできるのか？！",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "10:20~11:10", time: "50min", category: "映像"},
                {schedule: "11:40~12:30", time: "50min", category: "映像"},
                {schedule: "13:00~13:50", time: "50min", category: "映像"},
                {schedule: "14:20~15:10", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2A": {
            location: "2年A組教室",
            show_name: "輝け！四輪羅部",
            img: "/img/num9-min.jpeg",
            number: "No.009",
            category: ["映像"],
            type: "class",
            msg: "喜々☆快々",
            time_info_1day: [
                {schedule: "9:30~10:20", time: "50min", category: "映像"},
                {schedule: "11:00~11:50", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "15:00~15:50", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:30~10:20", time: "50min", category: "映像"},
                {schedule: "11:00~11:50", time: "50min", category: "映像"},
                {schedule: "13:30~14:20", time: "50min", category: "映像"},
                {schedule: "15:00~15:50", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2B": {
            location: "2年B組教室",
            show_name: "B術作品展覧会・B展",
            img: "/img/num10-min.jpeg",
            number: "No.010",
            category: ["映像","展示"],
            type: "class",
            msg: "メルヘンではない！！夢でもない！！現実でもないかもしれないしかし真実でなくてはならない！！—奈良美智",
            time_info_1day: [
                {schedule: "9:00~12:00", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            time_info_2day: [
                {schedule: "9:00~12:00", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2C": {
            location: "2年C組教室",
            show_name: "OWARI NO SEKAI ",
            img: "/img/num11-min.jpeg",
            number: "No.011",
            category: ["展示"],
            type: "class",
            msg: "西暦20XX年...人類は衰退し東京は緑に覆われる。終電。終わりの世界行き。",
            time_info_1day: [
                {schedule: "9:00~12:15", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            time_info_2day: [
                {schedule: "9:00~12:15", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2D":{
            location: "2年D組教室",
            show_name: "Return：帰ろう",
            img: "/img/num12-min.jpeg",
            number: "No.012",
            category: ["映像"],
            type: "class",
            msg: "普通の西高生の元にある日届いた一通のメール。開くや否や流れ出す不鮮明な「帰ろう」。日常が一通のメールで狂い出す。―――",
            time_info_1day: [
                {schedule: "9:10~10:00", time: "50min", category: "映像"},
                {schedule: "10:40~11:30", time: "50min", category: "映像"},
                {schedule: "13:10~14:00", time: "50min", category: "映像"},
                {schedule: "14:30~15:20", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:10~10:00", time: "50min", category: "映像"},
                {schedule: "10:40~11:30", time: "50min", category: "映像"},
                {schedule: "13:10~14:00", time: "50min", category: "映像"},
                {schedule: "14:30~15:20", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2E": {
            location: "2年E組教室",
            show_name: "真剣ゼミ",
            img: "/img/num13-min.jpeg",
            number: "No.013",
            category: ["映像"],
            type: "class",
            msg: "某有名通信教育講座のパロディを放映します。「真剣ゼミ」を通して、高校生たちがリアルを充実させていくストーリーです。こんなご時世だからこそ一緒に青春しませんか？【胸キュン必至!?】",
            time_info_1day: [
                {schedule: "9:00~9:30", time: "30min", category: "映像"},
                {schedule: "10:10~10:40", time: "30min", category: "映像"},
                {schedule: "11:20~11:50", time: "30min", category: "映像"},
                {schedule: "13:00~13:30", time: "30min", category: "映像"},
                {schedule: "14:10~14:40", time: "30min", category: "映像"},
                {schedule: "15:20~15:50", time: "30min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:30", time: "30min", category: "映像"},
                {schedule: "10:10~10:40", time: "30min", category: "映像"},
                {schedule: "11:20~11:50", time: "30min", category: "映像"},
                {schedule: "13:00~13:30", time: "30min", category: "映像"},
                {schedule: "14:10~14:40", time: "30min", category: "映像"},
                {schedule: "15:20~15:50", time: "30min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/2e",
            point :"auto",
            underLine: "underlines"
        },
        "2F": {
            location: "2年F組教室",
            show_name: "シン・Fァンゲリオン",
            img: "/img/num14-min.jpeg",
            number: "No.014",
            category: ["映像"],
            type: "class",
            msg: "これを見て笑えばいいと思うよ。\n―岩田シンジ",
            time_info_1day: [
                {schedule: "9:20~10:00", time: "40min", category: "映像"},
                {schedule: "11:00~11:40", time: "40min", category: "映像"},
                {schedule: "13:20~14:00", time: "40min", category: "映像"},
                {schedule: "15:40~16:20", time: "40min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:20~10:00", time: "40min", category: "映像"},
                {schedule: "11:00~11:40", time: "40min", category: "映像"},
                {schedule: "13:20~14:00", time: "40min", category: "映像"},
                {schedule: "15:40~16:20", time: "40min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2G": {
            location: "2年G組教室",
            show_name: "koujiの部屋",
            img: "/img/num15-min.jpeg",
            number: "No.015",
            category: ["アトラクション"],
            type: "class",
            msg: "閉ざされた扉、立ちはだかる四つの試練、君は再び廊下に出ることができるのか\n......2G...comingsoon......",
            time_info_1day: [
                {schedule: "9:40~10:30", time: "50min", category: "映像"},
                {schedule: "11:00~11:50", time: "50min", category: "映像"},
                {schedule: "12:20~13:10", time: "50min", category: "映像"},
                {schedule: "13:40~14:30", time: "50min", category: "映像"},
                {schedule: "15:15~16:05", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:40~10:30", time: "50min", category: "映像"},
                {schedule: "11:00~11:50", time: "50min", category: "映像"},
                {schedule: "12:20~13:10", time: "50min", category: "映像"},
                {schedule: "13:40~14:30", time: "50min", category: "映像"},
                {schedule: "15:15~16:05", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "2H":{
            location: "2年H組教室",
            show_name: "籠の中の鳥よ",
            img: "/img/num16-min.jpeg",
            number: "No.016",
            category: ["展示"],
            type: "class",
            msg: "かごめかごめかごのなかのとりはいついつでやうよあけのばんにつるとかめがすべったうしろのしょうめんだーれ",
            time_info_1day: [
                {schedule: "9:00~12:00", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            time_info_2day: [
                {schedule: "9:00~12:00", time: "午前", category: "展示"},
                {schedule: "12:45~16:30", time: "午後", category: "展示"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "16限目の碧": {
            location: "第一特別教室",
            show_name: "Noir",
            img: "/img/num17-min.jpeg",
            number: "No.017",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "つまりジャズバンドです",
            time_info_1day: [
                {schedule: "12:00~12:35", time: "35min", category: "映像/シュベルト　連結上映"},
                {schedule: "14:05~14:20", time: "15min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "14:05~14:20", time: "15min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        /*"つるばみ同好会": {
            location: "音楽室",
            show_name: "つるばみ",
            img: "/img/num18-min.jpeg",
            number: "No.018",
            category: ["パフォーマンス"],
            type: "club",
            msg: "音楽ライブを、やります！",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        },*/
        "化学部": {
            location: "化学実験室",
            show_name: "化学部",
            img: "/img/num19-min.jpeg",
            number: "No.019",
            category: ["展示"],
            type: "club",
            msg: "\u2081\u2089k\u2085\u2083I\u2085\u2082Te\u2081\u2080Ne\nきてね!!!!!!!!!!!!!!!!",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "工作サークル":{
            location: "工芸室",
            show_name: "万国博覧会",
            img: "/img/num20-min.jpeg",
            number: "No.020",
            category: ["展示"],
            type: "club",
            msg: "みなさん初めまして。変なものを作ります。工芸室なので視聴覚ホールに来たついでに来てくれると嬉しいです。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "SDGsの会": {
            location: "3年H組教室",
            show_name: "見る・知る・わかる　\nSDGs",
            img: "/img/num21-min.jpeg",
            number: "No.021",
            category: ["展示"],
            type: "club",
            msg: "「よくわからない...」「難しそう...」と思われがちなSDGsを、身近なもので目に見える形にして展示します！肩肘張らずにSDGsについて考えてみない？",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "『あの頃は、純粋だった。』制作委員会": {
            location: "3階渡り廊下",
            show_name: "あの頃は、\n純粋だった。",
            img: "/img/num22-min.jpg",
            number: "No.022",
            category: ["展示"],
            type: "volunteer",
            msg: "いっそのこと消えてしまえばいいあの記憶も、ここでなら＿＿",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "古文の会": {
            location: "3階渡り廊下",
            show_name: "最近我暇集",
            img: "/img/num23-min.jpeg",
            number: "No.023",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "KOBUN To TheFuture",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "地球温暖化に対抗する会":{
            location: "3階渡り廊下",
            show_name: "冷やし地球、\nはじめました",
            img: "/img/num24-min.jpg",
            number: "No.024",
            category: ["展示"],
            type: "volunteer",
            msg: "暖かいなら冷ませば良いことに気付きました。氷河期始まっちゃったらすみません。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "練馬区民の会": {
            location: "3階渡り廊下",
            show_name: "練馬区民の会",
            img: "/img/num25-min.png",
            number: "No.025",
            category: ["展示"],
            type: "volunteer",
            msg: "今年こそ、埼玉県とは言わせない。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "パスタが少し余っていたので・・・": {
            location: "3階渡り廊下",
            show_name: "ざんねんな\n西高生事典",
            img: "/img/num26-min.jpeg",
            number: "No.026",
            category: ["展示"],
            type: "volunteer",
            msg: "西高生はドングリを埋めた場所をすぐにわすれる\n西高生はモンシロチョウより飛ぶのがおそい\n西高生が一日中食べ続けるササの葉にはほとんど栄養がない",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "町田市民の会": {
            location: "3階渡り廊下",
            show_name: "おいでよ\n～町田の里～",
            img: "/img/num27-min.jpeg",
            number: "No.027",
            category: ["展示"],
            type: "volunteer",
            msg: "注）町田市は神奈川県ではありません。一様東京都というところに所属しています。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "75期HR委員会":{
            location: "3年G組教室",
            show_name: "この穴から顔出すの日和ってるやついる？\nいねぇよなぁ！",
            img: "/img/num28-min.jpeg",
            number: "No.028",
            category: ["展示"],
            type: "committee",
            msg: "まさか西高に「高校生にもなって顔出し看板に顔出すの恥ずかしい...」なんて人いませんよぇ",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "CR東日本": {
            location: "3年D組教室",
            show_name: "CR東日本",
            img: "/img/num29-min.jpeg",
            number: "No.029",
            category: ["展示"],
            type: "club",
            msg: "鉄道模型やダイヤグラム、写真、映像等部員の手筒同愛詰まったコンテンツを展示予定。今夏コンテストに出展したばかりのジオラマもお見逃しなく！",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "NERV西高支部": {
            location: "3年C組教室",
            show_name: "IT WILL (NOT) BE CONTINUED ",
            img: "/img/num30-min.jpeg",
            number: "No.030",
            category: ["展示"],
            type: "volunteer",
            msg: "さようなら、すべてのエヴァンゲリオン。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "NISHI FLYER": {
            location: "3年B組教室",
            show_name: "西空配布会",
            img: "/img/num31-min.jpeg",
            number: "No.031",
            category: ["展示"],
            type: "club",
            msg: "なんでCRは知ってるのにNFは知らないの？",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "origamiサークル":{
            location: "3年E組教室",
            show_name: "折",
            img: "/img/num32-min.jpeg",
            number: "No.032",
            category: ["展示"],
            type: "club",
            msg: "折り紙の奥深さを体験してください！",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "宇宙研究部": {
            location: "3年A組教室",
            show_name: "母なる宇宙",
            img: "/img/num33-min.jpeg",
            number: "No.033",
            category: ["展示"],
            type: "club",
            msg: "宇宙は永劫不変である。アルキメデスが咳で砂粒を吹き飛ばした時も、ガリレオがつぶやいた時も、ガンマ線がバーストした時も、君が睡眠学習をした時も、見上げれば、宇宙があった。部誌と映像と展示あり〼。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "架空同好会": {
            location: "3年G組教室",
            show_name: "「これらの作品はフィクションであり、\n実在の人物・団体とは一切関係ありません」",
            img: "/img/num34-min.jpeg",
            number: "No.034",
            category: ["展示"],
            type: "volunteer",
            msg: "想像できることは、すべて現実なのだ。\n_____パブロ・ピカソ",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "華道部": {
            location: "2階廊下",
            show_name: "和音",
            img: "/img/num35-min.jpeg",
            number: "No.035",
            category: ["展示"],
            type: "club",
            msg: "清楚枠としてこの学校に君臨する華道部。しかし今回は少し様子が違うそうだ...。和音を体現した、我々の作品を見て華道の概念を変えていって欲しい。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "かるた部":{
            location: "3年A組教室",
            show_name: "あまつかぜ",
            img: "/img/num36-min.jpeg",
            number: "No.036",
            category: ["展示"],
            type: "club",
            msg: "かるた部で部内戦をしました！かるた部員のひと夏の成長記録頑張ったので見てください\n٩( ᐛ )و",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "数学研究同好会": {
            location: "3年E組教室",
            show_name: "数研",
            img: "/img/num37-min.jpeg",
            number: "No.037",
            category: ["展示"],
            type: "club",
            msg: "特に書くことないので自然対数の底でも書いときますね。\n2.71828182845904523536028...",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "西論会": {
            location: "3年C組教室",
            show_name: "西論会\n2021記念祭号",
            img: "/img/num38-min.jpeg",
            number: "No.038",
            category: ["展示"],
            type: "club",
            msg: "西論会は、西高のはぐれ物、一匹狼、変わり者オタク、問題児、唯一の常識人、そういった人間の集まりだ。気にせずに来てくれ。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "文芸部": {
            location: "3年F組教室",
            show_name: "たまゆら",
            img: "/img/num39-min.jpeg",
            number: "No.039",
            category: ["展示"],
            type: "club",
            msg: "喧騒から逃げ出すと、ある教室に心を奪われた。初めて見た言葉に、思わず立ち止まる。「玉響......？」私はほんの少しの間だけ、部屋に避難した。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "歴史研究部":{
            location: "3年B組教室",
            show_name: "甍\n2021記念祭号",
            img: "/img/num40-min.jpeg",
            number: "No.040",
            category: ["展示"],
            type: "club",
            msg: "歴研の部誌『甍』の配布を行います。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "74期サークル志記": {
            location: "視聴覚ホール",
            show_name: "蒲田行進曲",
            img: "/img/num41-min.jpeg",
            number: "No.041",
            category: ["劇"],
            type: "volunteer",
            msg: "若手俳優と売れない新人女優、そして大部屋の3人が繰り広げる愛憎劇の西高ver!!あなたの西高生度が分かるかもしれません...",
            time_info_1day: [
                {schedule: "15:20~16:10", time: "50min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "15:20~16:10", time: "50min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "ダンス部75×76": {
            location: "視聴覚ホール",
            show_name: "KEEP ON DANCING",
            img: "/img/num42-min.jpeg",
            number: "No.042",
            category: ["パフォーマンス"],
            type: "club",
            msg: "世界中が熱狂するあの大人気グループが75×76の新体制で西高にやってくる！！こんな機会、絶対に逃すなよ？",
            time_info_1day: [
                {schedule: "11:00~11:10", time: "10min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "11:00~11:10", time: "10min", category: "映像"},
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/dance",
            point :"auto",
            underLine: "underlines"
        },
        "剣道部": {
            location: "視聴覚ホール",
            show_name: "人生劇場2021　\n涼馬伝",
            img: "/img/num43-min.jpeg",
            number: "No.043",
            category: ["劇"],
            type: "club",
            msg: "脚本書くのってホント面倒くせーな。あー、チーズ蒸○パンになりたい。",
            time_info_1day: [
                {schedule: "12:40~13:30", time: "50min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "12:40~13:30", time: "50min", category: "映像"},
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/kendo",
            point :"auto",
            underLine: "underlines"
        },
        "浪漫倶楽部":{
            location: "視聴覚ホール",
            show_name: "浪漫倶楽部",
            img: "/img/num44-min.jpeg",
            number: "No.044",
            category: ["映像"],
            type: "volunteer",
            msg: "浪漫倶楽部の名前は米米CLUBの浪漫飛行からとったらしいです、ウソです",
            time_info_1day: [
                {schedule: "14:00~14:50", time: "50min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "14:00~14:50", time: "50min", category: "映像"},
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/roman",
            point :"auto",
            underLine: "underlines"
        },
        "ヲタ芸サークル": {
            location: "視聴覚ホール",
            show_name: "Sparkle",
            img: "/img/num45-min.jpeg",
            number: "No.045",
            category: ["パフォーマンス"],
            type: "club",
            msg: "こんにちは！ヲタ芸とはサイリウムを使って光の曲線で表現するパフォーマンスです。光が作り出す世界、是非ご覧ください！",
            time_info_1day: [
                {schedule: "9:00~9:20", time: "20min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "9:00~9:20", time: "20min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "図書委員会": {
            location: "図書室",
            show_name: "納涼図書館祭り",
            img: "/img/num46-min.jpeg",
            number: "No.046",
            category: ["展示"],
            type: "committee",
            msg: "校内の喧騒を尻目に存在する安寧の場所。そんな図書室が3階、西高の最果てにあります。ゆらゆらとおいでください。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "執行委員会": {
            location: "生徒会室",
            show_name: "「大改造！！\n劇的ビフォーアフター　\n〜西高生徒会室〜」",
            img: "/img/num47-min.jpeg",
            number: "No.047",
            category: ["展示"],
            type: "committee",
            msg: "長年、物の乱雑さが問題となっていた生徒会室。そんな場所を、影が薄いで有名の執行委員会が片付ける!涙あり、感動ありの物語をとくとご覧あれ!、、、というかお願いです見てください(土下座)こんな時くらいしか活躍みせれn",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "生物部":{
            location: "生物室",
            show_name: "物部は\n生物部です。",
            img: "/img/num48-min.jpeg",
            number: "No.048",
            category: ["展示"],
            type: "club",
            msg: "生き物・解剖実演・部誌、その他展示...\n生き物に興味ある人来てね！\n物部の座は生物部が頂きます。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "管弦楽部": {
            location: "体育館",
            show_name: "majiでokeする\n5秒前",
            img: "/img/num49-min.jpeg",
            number: "No.049",
            category: ["パフォーマンス"],
            type: "club",
            msg: "仮面舞踏会って少年隊(ジャニーズ)だけじゃないんだよね。こっちは皆さんお馴染みハチャトゥリアンです。どうも、ワルツ大好き管弦楽部です。",
            time_info_1day: [
                {schedule: "9:20~10:10", time: "50min", category: "映像"},
                {schedule: "12:40〜13:30", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "11:30~12:20", time: "50min", category: "映像"},
                {schedule: "15:00〜15:50", time: "50min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "第2音楽部": {
            location: "第一社会科教室",
            show_name: "ゲーム音楽\nおっぺけペー",
            img: "/img/num50-min.jpg",
            number: "No.050",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "たかが１７歳、されど１７歳、積年の音楽・ゲームへの熱を持ち寄ってゲーム音楽を演奏します。",
            time_info_1day: [
                {schedule: "11:30~11:50", time: "20min", category: "映像"},
                {schedule: "14:50~15:10", time: "20min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "", time: "", category: ""},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "吹奏楽部": {
            location: "体育館/第二特別教室",
            show_name: "FESTIVAL BRASS 2021",
            img: "/img/num51-min.jpeg",
            number: "No.051",
            category: ["パフォーマンス"],
            type: "club",
            msg: "今年こそ―――それは矜持か反撃か。体育館にて、魂込めて演奏します。生演奏の迫力をあなたに。",
            time_info_1day: [
                {schedule: "11:20〜12:10", time: "50min", category: "映像/体育館"},
                {schedule: "15:00〜15:50", time: "50min", category: "映像/体育館"},
                {schedule: "16:15~16:20", time: "5min", category: "映像/第二特別教室"},
            ],
            time_info_2day: [
                {schedule: "10:00〜10:50", time: "50min", category: "映像/体育館"},
                {schedule: "13:00〜13:50", time: "50min", category: "映像/体育館"},
                {schedule: "16:15~16:20", time: "5min", category: "映像/第二特別教室"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "秘密結社ベトリナ":{
            location: "第二社会科教室",
            show_name: "Useless For Our daily life ",
            img: "/img/num52-min.jpeg",
            number: "No.052",
            category: ["展示"],
            type: "club",
            msg: "無駄を愛し、無駄に愛された者たちによる無駄に満ちた世界へ是非お越しください。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "ワンダーフォーゲル部": {
            location: "第二社会科教室",
            show_name: "山に登りたかった\nワンゲル部",
            img: "/img/num53-min.jpeg",
            number: "No.053",
            category: ["展示"],
            type: "club",
            msg: "ついに我々は山行実施（高水）に成功した。この感動を伝えるべく奥多摩山域の模型を！",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "Lily": {
            location: "第一特別教室",
            show_name: "Lily",
            img: "/img/num54-min.jpg",
            number: "No.054",
            category: ["映像"],
            type: "volunteer",
            msg: "嫉妬と欲望が、人を壊す圧倒的映像美でお届けする本格派ミステリー",
            time_info_1day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:50", time: "50min", category: "映像"},
                {schedule: "12:00~12:50", time: "50min", category: "映像"},
                {schedule: "15:40~16:30", time: "50min", category: "映像"}
            ],
            booking:"あり",
            url: "https://kinensai-res.vercel.app/#/res/lily",
            point :"auto",
            underLine: "underlines"
        },
        "シュベルト": {
            location: "第一特別教室",
            show_name: "狼煙の上がった夜",
            img: "/img/num55-min.jpeg",
            number: "No.055",
            category: ["映像"],
            type: "volunteer",
            msg: "7月29日11時00分頃、高尾駅上空に出現し、同30分頃に着陸。東へ自足6kmで歩行を開始。市街地に被害をもたらした。↩",
            time_info_1day: [
                {schedule: "10:20~10:40", time: "20min", category: "映像"},
                {schedule: "12:00~12:35", time: "35min", category: "映像/16限目の瞳　連結上映"},
                {schedule: "14:50~15:10", time: "20min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "10:20~10:40", time: "20min", category: "映像"},
                {schedule: "14:50~15:10", time: "20min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "新体操有志":{
            location: "第一特別教室",
            show_name: "WE♡R.G.",
            img: "/img/num56-min.jpeg",
            number: "No.056",
            category: ["映像"],
            type: "volunteer",
            msg: "もう一度、踊りたい。\n新体操経験者によるパフォーマンス映像です。\n全4曲＋αの演技を披露します。\nせーの、がんば！",
            time_info_1day: [
                {schedule: "11:10~11:25", time: "15min", category: "映像"},
                {schedule: "13:20~13:35", time: "15min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "11:10~11:25", time: "15min", category: "映像"},
                {schedule: "13:20~13:35", time: "15min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "NBA": {
            location: "第一社会科教室",
            show_name: "nBAかっこいい",
            img: "/img/num57-min.jpeg",
            number: "No.057",
            category: ["映像"],
            type: "club",
            msg: "最強の日常。",
            time_info_1day: [
                {schedule: "9:00~9:20", time: "20min", category: "映像"},
                {schedule: "12:20~12:40", time: "20min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:00~9:20", time: "20min", category: "映像"},
                {schedule: "14:00~14:20", time: "20min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        /*"スタジオふれ": {
            location: "第二社会科教室",
            show_name: "露草色の回顧録",
            img: "/img/num58-min.jpeg",
            number: "No.058",
            category: ["映像"],
            type: "volunteer",
            msg: "拝啓━━━━━遺された一通の手紙。その選択は時を超え、少女の背中を押す。記念祭大賞３位を受賞した旧1Dが再集結！",
            time_info: [
                {schedule: "10:00~11:00", time: "60min", category: "映像"},
                {schedule: "13:00~14:00", time: "60min", category: "映像"}
            ],
            booking:"無し",
            url: ""
        },*/
        "放送部": {
            location: "第一社会科教室",
            show_name: "the⭐︎声劇 \nほぅ、そうかい",
            img: "/img/num59-min.jpeg",
            number: "No.059",
            category: ["映像"],
            type: "club",
            msg: "―――人は、声だけで泣ける。\n朗読のプロ、放送部による本気の音声劇です。",
            time_info_1day: [
                {schedule: "9:50~10:10", time: "20min", category: "映像"},
                {schedule: "13:10~13:30", time: "20min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:50~10:10", time: "20min", category: "映像"},
                {schedule: "12:20~12:40", time: "20min", category: "映像"},
                {schedule: "14:50~15:10", time: "20min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "74th食販有志":{
            location: "1Dと1Eの間 ",
            show_name: "食販は74(なし)です！\n(あります)\n※中止になりました",
            img: "/img/num60-min.jpg",
            number: "No.060",
            category: ["展示"],
            type: "volunteer",
            msg: "オリンピックはやるんだね（笑）",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "園芸部": {
            location: "中庭の花壇/保健室横の掲示板",
            show_name: "Nishi Garden",
            img: "/img/num61-min.jpeg",
            number: "No.061",
            category: ["展示"],
            type: "club",
            msg: "園芸はお嬢様の嗜みですって？とんでもない！男子部員もいますよ！汗水流して完成させた花壇を是非間近でご覧あれ！",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "NIN": {
            location: "2階渡り廊下",
            show_name: "NIN",
            img: "/img/num62-min.jpeg",
            number: "No.062",
            category: ["展示"],
            type: "club",
            msg: "「こあらくんはいんてりだね」\n「いやーそれほどでもないです」",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "Pas de Huit (パドユイット)": {
            location: "第一社会科教室",
            show_name: "Etoile-エトワール-",
            img: "/img/num63-min.jpeg",
            number: "No.063",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "昨年度74期生8名により立ち上げられたバレエ有志団体、Pas de Huit。今回新たに75,6期生メンバーを迎え、今年もクラシックバレエの枠にとらわれないこだわりの映像作品をお届けします。",
            time_info_1day: [
                {schedule: "10:40~11:00", time: "20min", category: "映像"},
                {schedule: "14:00~14:20", time: "20min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "10:40~11:00", time: "20min", category: "映像"},
                {schedule: "13:10~13:30", time: "20min", category: "映像"},
                {schedule: "15:40~16:00", time: "20min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "写真部":{
            location: "2階渡り廊下",
            show_name: "写真展",
            img: "/img/num64-min.jpg",
            number: "No.064",
            category: ["展示"],
            type: "club",
            msg: "学校行事や個人で撮影した写真を展示します。移動するときに渡り廊下を見ていってください。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "新聞部": {
            location: "2階渡り廊下",
            show_name: "學苑編年史",
            img: "/img/num65-min.jpeg",
            number: "No.065",
            category: ["映像"],
            type: "club",
            msg: "今日に至るまでの学校新聞『學苑』の記念祭に関する記事から、記念祭の歴史と西高生の関心事の変遷を紹介します。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "卵かけご飯同好会": {
            location: "2階渡り廊下",
            show_name: "シン・帰ってきた卵かけご飯 \nリターンズ2 〜lost memory〜",
            img: "/img/num66-min.jpeg",
            number: "No.066",
            category: ["展示"],
            type: "volunteer",
            msg: "手打ちのちぢれ麺は国産小麦を100%使用しており、コシのある食感と豊かな風味、気持ちの良いのどごしが特徴です。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "都立西高等学校駄洒落倶楽部": {
            location: "2階渡り廊下",
            show_name: "あっ。。。冊子",
            img: "/img/num67-min.jpeg",
            number: "No.067",
            category: ["展示"],
            type: "club",
            msg: "これは部誌で候ふ",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "ポケモン研究サークル":{
            location: "2階渡り廊下",
            show_name: "ポケットモンスター、\n縮めてケンタ",
            img: "/img/num68-min.jpeg",
            number: "No.068",
            category: ["展示"],
            type: "club",
            msg: "君の心をゲットだぜ！！",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "イラスト研究部": {
            location: "美術室",
            show_name: "いらすと\nけんきゅーぶ",
            img: "/img/num69-min.jpeg",
            number: "No.069",
            category: ["展示"],
            type: "club",
            msg: "イラ研では今年も部誌の配布を行います。74期のイラストを見れるのは今回が最後！大好評のフルカラー本もいっぱい作ったのでぜひ来てください！在庫が残ったら部長が泣きます",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "美術部": {
            location: "美術室",
            show_name: "透い絵",
            img: "/img/num70-min.jpeg",
            number: "No.070",
            category: ["展示"],
            type: "club",
            msg: "おいでおいでおいで",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "物理部": {
            location: "物理講義室",
            show_name: "物理の部屋",
            img: "/img/num71-min.jpeg",
            number: "No.071",
            category: ["展示"],
            type: "club",
            msg: "物理って、なんか堅苦しい分野だと思ってませんか？それ、偏見ですよ。\n一般相対性理論からピタゴラ装置まで、幅広～く扱ってます。",
            time_info_1day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            time_info_2day: [
                {schedule: "10:00~17:00", time: "一日", category: "展示"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "NWO74th":{
            location: "第二特別教室",
            show_name: "【神回】\n吹奏楽部74期が悪足掻きしてみた！！！\n引退後の吹部員、その腕前は...?\n【衝撃のラスト】",
            img: "/img/num72-min.jpeg",
            number: "No.072",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "これはとある吹奏楽部の話である。群れを好み、笑いを好み、音楽を好み、溢れんばかりの個性とたたき上げの変顔だけが彼らの武器だ。都立西高校吹奏楽部74期、またの名を「NWO74th」",
            time_info_1day: [
                {schedule: "11:05~11:15", time: "10min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "11:05~11:15", time: "10min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "aile": {
            location: "第二特別教室 ",
            show_name: "In Your Area",
            img: "/img/num73-min.jpeg",
            number: "No.073",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "羽(aile)のごとく現れた4人組。BLACKPINKの完コピに挑む!!︎",
            time_info_1day: [
                {schedule: "11:35~11:45", time: "10min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "11:35~11:45", time: "10min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        /*"Brass Band Basics": {
            location: "野外ステージ",
            show_name: "すいそう！\n(けいおんのロゴ)",
            img: "/img/num74-min.jpeg",
            number: "No.074",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "吹奏楽のガチガチの定番曲をこれでもかともりもり演奏する74期有志団体です！！！ききにきてね",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        },*/
        "BTMⅡ": {
            location: "第二特別教室",
            show_name: "Magic Shop @ nhs",
            img: "/img/num75-min.jpeg",
            number: "No.075",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "私たちは世界的にヒットしたDYNAMITEをはじめとするBTSの曲のダンスを披露します。「共鳴」しあえる場所、Magic Shopへぜひお越しください！",
            time_info_1day: [
                {schedule: "10:00~10:05", time: "5min", category: "映像"},
                {schedule: "13:45~13:50", time: "5min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "10:00~10:05", time: "5min", category: "映像"},
                {schedule: "13:45~13:50", time: "5min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "FM75×76":{
            location: "第二特別教室 ",
            show_name: "FLASH MOB 2021",
            img: "/img/num76-min.jpeg",
            number: "No.076",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "耳を澄ませばどこからか音楽が...吹部有志による『宝島』をお楽しみください！",
            time_info_1day: [
                {schedule: "9:00~9:10", time: "10min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "9:00~9:10", time: "10min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        /*"Western Spring": {
            location: "野外ステージ",
            show_name: "Here comes the Spring",
            img: "/img/num77-min.jpeg",
            number: "No.077",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "我々Western Springのホームグラウンドである中庭での最後の演奏をお楽しみ下さい！",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        },*/
        "軽音楽同好会": {
            location: "第二特別教室",
            show_name: "けいおんらいぶ",
            img: "/img/num78-min.jpeg",
            number: "No.078",
            category: ["パフォーマンス"],
            type: "club",
            msg: "けいおんらいぶ！はじまりはじまりー！！",
            time_info_1day: [
                {schedule: "15:05~15:55", time: "50min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "15:05~15:55", time: "50min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "ケルト音楽研究サークル": {
            location: "第二特別教室",
            show_name: "ケルトの音楽会 2021",
            img: "/img/num79-min.jpeg",
            number: "No.079",
            category: ["パフォーマンス"],
            type: "club",
            msg: "ケルト地方の伝統的な曲を演奏します。",
            time_info_1day: [
                {schedule: "12:05~12:25", time: "20min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "12:05~12:25", time: "20min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "ゴスペルフリークス部":{
            location: "第二特別教室",
            show_name: "ゴスフリ\n〜共鳴外縁天体〜",
            img: "/img/num80-min.jpeg",
            number: "No.080",
            category: ["パフォーマンス"],
            type: "club",
            msg: "ゴスペルフリークス部って何？って人、見に来たらわかります！合唱曲から外国の曲まで幅広く歌っています！コロナ禍で歌いたい欲が溜まりに溜まった部員たちの歌声をお聴きください！！",
            time_info_1day: [
                {schedule: "10:25~10:45", time: "20min", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "10:25~10:45", time: "20min", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "鼓絆": {
            location: "第二特別教室",
            show_name: "この一打に\n真を込めて",
            img: "/img/num81-min.jpeg",
            number: "No.081",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg: "こんにちは！西高有志和楽器集団、鼓絆(こはん)です。７４期と７５期の迫力ある演奏をお楽しみください！",
            time_info_1day: [
                {schedule: "9:30~9:40", time: "10min", category: "映像"},
                {schedule: "14:10~14:20", time: "10min", category: "映像"}
            ],
            time_info_2day: [
                {schedule: "9:30~9:40", time: "10min", category: "映像"},
                {schedule: "14:10~14:20", time: "10min", category: "映像"}
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        "シブ楽隊":{
            location: "第二特別教室",
            show_name: "シブい共鳴",
            img: "/img/num82-min.jpeg",
            number: "No.082",
            category: ["パフォーマンス"],
            type: "club",
            msg: "軽やかな四分の足取りなのか、はたまた渋く響く音色なのか、その『しぶ』とはどのような意味なのだろうか...その謎を解明するため、我々調査隊はアマゾンの奥地へと向かったー",
            time_info_1day: [
                {schedule: "14:40~14:45", time: "一日", category: "映像"},
            ],
            time_info_2day: [
                {schedule: "14:40~14:45", time: "一日", category: "映像"},
            ],
            booking:"無し",
            url: "",
            point :"none",
            underLine: "none"
        },
        /*"男子バスケットボール部": {
            location: "野外ステージ",
            show_name: "120%笑える漫才",
            img: "/img/num83-min.jpeg",
            number: "No.083",
            category: ["パフォーマンス"],
            type: "club",
            msg: "",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        },*/
        /*"ふえ部": {
            location: "野外ステージ",
            show_name: "ふえ部",
            img: "/img/num84-min.jpeg",
            number: "No.084",
            category: ["パフォーマンス"],
            type: "club",
            msg: "リコーダーって奥が深い。",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        },*/
        /*"管打の集い": {
            location: "野外ステージ",
            show_name: "だってやりたかったんだもん",
            img: "/img/num85-min.jpeg",
            number: "No.085",
            category: ["パフォーマンス"],
            type: "volunteer",
            msg:"だってこの曲やりたかったんだもん！金管８重奏｢てぃーちてぃーる｣で沖縄へ、合奏｢リバーダンス｣でアイルランドへ！",
            time_info: [
                {schedule: "10:00~10:30", time: "30min", category: "パフォーマンス"},
                {schedule: "13:00~13:30", time: "30min", category: "パフォーマンス"}
            ],
            booking:"無し",
            url: ""
        }*/
    }
}